import React, { useEffect } from "react";
import { useState } from "react";

const radio = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z"
      fill="#CE2032"
      stroke="#CE2032"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1801 5.81977C12.5985 6.23769 12.9304 6.73399 13.1569 7.28028C13.3833 7.82658 13.4999 8.41215 13.4999 9.00352C13.4999 9.59489 13.3833 10.1805 13.1569 10.7267C12.9304 11.273 12.5985 11.7693 12.1801 12.1873M5.82011 12.1798C5.40171 11.7618 5.0698 11.2655 4.84334 10.7192C4.61688 10.173 4.50032 9.58739 4.50032 8.99602C4.50032 8.40465 4.61688 7.81908 4.84334 7.27278C5.0698 6.72649 5.40171 6.23019 5.82011 5.81227M14.3026 3.69727C15.7086 5.10372 16.4985 7.01103 16.4985 8.99977C16.4985 10.9885 15.7086 12.8958 14.3026 14.3023M3.69761 14.3023C2.29157 12.8958 1.50171 10.9885 1.50171 8.99977C1.50171 7.01103 2.29157 5.10372 3.69761 3.69727"
      stroke="#414651"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const chevron = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="#414651"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StationSelect = ({ stations }) => {
  const currentStation = JSON.parse(localStorage.getItem("audioInfo")) || {id: 0};
  const [station, setStation] = useState(
    stations.find((e) => e.id == currentStation.id) || stations[0]
  );
  const [showStations, setShowStations] = useState(false);

  const getStationProgram = async (stationId) => {
    try {
      const res = await fetch("/api/v1/stations");
      const body = await res.json();
      console.log(body.data.stations)
      const station = body.data.stations.find(st => st.id == stationId);
      return station.live_program;
    } catch (err) {
      console.warn(err);
    }
  };

  const handleStationChange = async (station) => {
    const liveProgram = await getStationProgram(station.id);
    
    localStorage.setItem("showPlayer", "true")
    localStorage.setItem(
      "audioInfo",
      JSON.stringify({
        id: station.id == 1 ? '961' : '907',
        name: station.name,
        frequency: station.frequency,
        logo: station.logo,
        live: true,
        src: station.feed_url,
        liveProgram: liveProgram
      })
    );
    localStorage.setItem("isPlaying", true);
    window.dispatchEvent(new Event("storage")); // Trigger a storage event to notify other components

    setStation(station);
    setShowStations(false);
  };

  useEffect(() => {
    if (currentStation.id == 0) {
      handleStationChange(station)
    }
  }, [])

  return (
    <div className="station-select">
      <label>ESTÁS ESCUCHANDO:</label>
      <button aria-label="Seleccionar estación" onClick={() => setShowStations(!showStations)}>
        {radio}
        <span>{station.name}</span>
        {chevron}
      </button>

      {showStations && (
        <div className="station-select__stations">
          {stations.map((s) => (
            <button onClick={() => handleStationChange(s)}>
              {radio} {s.frequency} FM
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default StationSelect;
